module.exports = __webpack_public_path__ + "media/images/articles/default_avatar-8fe36744b6af5cd4d68d14d17a9e9039.png";